module.exports = __webpack_public_path__ + "static/img/3.ed517aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/3.png
// module id = AzTL
// module chunks = 0